import React, { useState, useEffect } from "react";
import {
  Breadcrumb,
  Button,
  Select,
  Image,
  Table,
  Input,
  Modal,
  notification,
} from "antd";
import { callApi } from "../../api/apiCaller";
import routes from "../../api/routes";
import Loader from "../../components/loader/loader";
import {
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { GreenNotify, RedNotify } from "../../helper/helper";
import Category from "../../components/updateTrainer/updateTrainer";
import { homeIcon } from "../../assets";

const Organizers = () => {
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [updateRecordData, setUpdateRecordData] = useState(null);
  const [isAddCategoryModalVisible, setIsAddCategoryModalVisible] =
    useState(false);
  const [expandedDescription, setExpandedDescription] = useState(null);

  const getAllCategories = () => {
    callApi("GET", routes.getTrainer, null, setIsLoading, (res) => {
      console.log("resp", res);
      setCategories(res?.data?.trainer || []);
    });
  };

  useEffect(() => {
    getAllCategories();
  }, []);
  const showFullDescription = (text) => {
    Modal.info({
      title: "Description",
      content: (
        <div>
          <p style={{ textAlign: "justify" }}>{text}</p>
        </div>
      ),
      onOk() {},
    });
  };
  const handleDelete = (recordId) => {
    callApi(
      "DELETE",
      `${routes.deleteTrainer}/${recordId}`,
      null,
      setIsLoading,
      (res) => {
        if (res.status === 200) {
          setCategories((prevVideos) =>
            prevVideos.filter((video) => video._id !== recordId)
          );
          GreenNotify("Trainer Deleted Successfully");
        } else {
          RedNotify("Error Occurred while deleting stage");
        }
      },
      (error) => {
        notification.error({
          message: "Error",
          description: "An error occurred while deleting the stage.",
        });
      }
    );
  };

  const handleAddYoga = () => {
    setUpdateRecordData(null);
    setIsAddCategoryModalVisible(true);
  };

  const handleEditYoga = (recordId) => {
    const selectedCategory = categories.find((cat) => cat._id === recordId);
    setUpdateRecordData(selectedCategory);
    setIsAddCategoryModalVisible(true);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      className: "type-name-column-header",
      align: "center",
    },
    {
      title: "Email",
      dataIndex: "email",
      className: "type-name-column-header",
      align: "center",
    },
    {
      title: "Whatsapp",
      dataIndex: "WhatsAppLink",
      className: "type-name-column-header",
      align: "center",
    },
    {
      title: "Instgram",
      dataIndex: "instLink",
      className: "type-name-column-header",
      align: "center",
    },
    // {
    //   title: "LinkedIn",
    //   dataIndex: "LinkedInLink",
    //   className: "type-name-column-header",
    //   align: "center",
    // },
    {
      title: "Description",
      dataIndex: "description",
      className: "type-name-column-header",
      align: "center",
      render: (text, record) => (
        <div>
          {expandedDescription === record.key ? (
            <span>{text}</span>
          ) : (
            <div>
              <span>{`${text.slice(0, 50)}...`}</span>
              <Button type="link" onClick={() => showFullDescription(text)}>
                See More
              </Button>
            </div>
          )}
        </div>
      ),
    },
    {
      title: "Image",
      dataIndex: "image",
      align: "center",
      render: (icon) => (
        <div className="product-list-image">
          <Image
            style={{
              width: 100,
              height: 100,
              borderRadius: 50,
              objectFit: "cover",
            }}
            src={icon}
            alt="trainer-image"
          />
        </div>
      ),
    },
    {
      title: "Action",
      dataIndex: "_id",
      className: "type-name-column-header",
      align: "center",
      render: (text, record) => (
        <div style={{ whiteSpace: "nowrap" }}>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => handleEditYoga(record._id)}
            style={{ marginRight: 8 }}
          ></Button>
          {/* <Button
            type="danger"
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record._id)}
            style={{ marginRight: 8 }}
          ></Button> */}
        </div>
      ),
      width: "auto",
    },
  ];

  const data = categories
    ?.map((item, index) => {
      const mappedItem = {
        key: item?._id,
        _id: item?._id,
        name: item?.name,
        description: item?.description,
        image: item?.image,
        email: item?.email,
        instLink: item?.instLink,
        WhatsAppLink: item?.WhatsAppLink,
        LinkedInLink: item?.LinkedInLink,
      };
      return mappedItem;
    })
    .filter((item) =>
      item?.name?.toLowerCase().includes(searchText.toLowerCase())
    );

  const getRowClassName = (record, index) =>
    index % 2 === 0 ? "server-role-even-row" : "server-role-odd-row";

  const handleCloseModal = () => {
    setModalVisible(false);
  };

  return (
    <div className="admin-products-main-container">
      <Loader loading={isLoading} />
      <Breadcrumb separator=">" className="bread-crumb">
        <div className="configure-server-home-icon">
          <img src={homeIcon} alt="home-icon" />
        </div>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>Trainer</Breadcrumb.Item>
      </Breadcrumb>
      <div className="configure-server-roles-main-heading-container">
        <h1>Trainer</h1>
        <div></div>
        {/* <div className="search-inputs" style={{ width: "30rem" }}>
          <Input
            placeholder="Search..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div> */}
      </div>
      {/* <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={handleAddYoga}
        style={{ marginBottom: "16px" }}
      >
        Add Trainer
      </Button> */}
      <div className="server-roles-tb-main-container">
        <Table
          rowClassName={getRowClassName}
          columns={columns}
          dataSource={data}
          pagination={true}
          className="subscriptionapi-table"
        />
      </div>

      <Category
        visible={isAddCategoryModalVisible}
        toggleModal={() => {
          setIsAddCategoryModalVisible(false);
          getAllCategories();
        }}
        recordData={updateRecordData}
      />
    </div>
  );
};

export default Organizers;
